/* eslint no-inner-declarations: 0 */
/* eslint no-use-before-define: 0 */

import jQuery from "jquery";
import { firecarouselInitializationRequested } from "@sharedFrontend/globalEvents";

(function main($) {
    function checkIfDisabled() {
        return !!document.getElementsByClassName("disable-premise-details").length;
    }

    $(document).ready(() => {
        if (checkIfDisabled()) {
            return;
        }

        const tileListContainer = $(".tile-list-container").first();
        const premiseDetailsPanelContainer = $(".premise-details-panel-container").first();
        if (
            premiseDetailsPanelContainer.length
            && tileListContainer.length
            && tileListContainer.data("experience-editor") !== "True"
        ) {
            $(".tile").bind("click", handleOnTileClick);
            $(".tile-tab-label").bind("click", handleOnDetailsClick);
            $(".premise-details-content .close-btn-container").bind("click", handleOnCloseBtnClick);

            function handleOnTileClick(event) {
                $(".tile").removeClass("active");
                const targetElement = $(event.target);
                if (
                    targetElement.hasClass("slick-arrow")
                    || targetElement.parents().hasClass("slick-arrow")
                    || targetElement.hasClass("popup-viewer-open-btn")
                    || targetElement.parents().hasClass("popup-viewer-open-btn")
                ) {
                    return;
                }

                const currentTileId = $(this).data("id");
                const premiseDetailsRadio = $(`#premise-details-radiobutton-${currentTileId}`);
                if (premiseDetailsRadio != null) {
                    premiseDetailsRadio.prop("checked", true);
                }

                const tileTabRadios = $(`.tile-tab-${currentTileId}`);
                if (tileTabRadios.length) {
                    tileTabRadios.first().prop("checked", true);
                    $(this).addClass("active");
                }

                // jquery need to be here as global variable
                const currentPremiseDetailsPanel = window.$(`#premise-details-panel-${currentTileId}`);
                if (currentPremiseDetailsPanel != null && typeof currentPremiseDetailsPanel.offset() !== "undefined") {
                    $("html, body").animate(
                        {
                            scrollTop: currentPremiseDetailsPanel.offset().top,
                        },
                        500,
                    );

                    // init carousel manually
                    const possibleCarouselInsideOfPremiseDetails = currentPremiseDetailsPanel.find(
                        ".sitecore-carousel-component",
                    );
                    if (possibleCarouselInsideOfPremiseDetails.length > 0) {
                        firecarouselInitializationRequested(possibleCarouselInsideOfPremiseDetails.eq(0));
                    }
                }

            }

            function handleOnDetailsClick() {
                const currentTileId = $(this)
                    .parents(".premise-details-panel")
                    .data("tile-id");
                const premiseDetailsRadioId = `premise-details-radiobutton-${currentTileId}`;
                const premiseDetailsRadio = $(`#${premiseDetailsRadioId}`);
                if (premiseDetailsRadio != null) {
                    if (premiseDetailsRadio.prop("checked")) {
                        premiseDetailsRadio.prop("checked", false);
                    } else {
                        premiseDetailsRadio.prop("checked", true);
                    }
                }

                const tileTabRadioClass = `tile-tab-${currentTileId}`;
                const tileTabRadios = $(`.${tileTabRadioClass}`);
                if (tileTabRadios.length) {
                    const tileTabRadio = tileTabRadios.first();
                    if (tileTabRadio.prop("checked")) {
                        tileTabRadio.prop("checked", false);

                    } else {
                        tileTabRadio.prop("checked", true);
                    }
                }


                const currentPremiseDetailsPanel = window.$(`#premise-details-panel-${currentTileId}`);

                // init carousel manually
                const possibleCarouselInsideOfPremiseDetails = currentPremiseDetailsPanel.find(
                    ".sitecore-carousel-component",
                );
                if (possibleCarouselInsideOfPremiseDetails.length > 0) {
                    firecarouselInitializationRequested(possibleCarouselInsideOfPremiseDetails.eq(0));
                }
            }

            function handleOnCloseBtnClick() {
                const currentTileId = $(this)
                    .parents(".premise-details-panel")
                    .data("tile-id");
                const premiseDetailsRadio = $(`#premise-details-radiobutton-${currentTileId}`);
                if (premiseDetailsRadio != null) {
                    premiseDetailsRadio.prop("checked", false);
                }

                const tileTabRadios = $(`.tile-tab-${currentTileId}`);
                if (tileTabRadios.length) {
                    tileTabRadios.first().prop("checked", false);
                    tileTabRadios.next(".tile").removeClass("active");
                }
            }
        }
    });
}(jQuery));
